import { createTheme, ThemeProvider, ThemeOptions } from '@mui/material/styles'
import type {} from '@mui/lab/themeAugmentation'
import { useMemo } from 'react'
import { ThemeInterface } from './interfaces'
import { semantic } from 'styles/tokens'

interface ThemeSiteProps extends ThemeInterface {
  primaryColor?: string
  secondaryColor?: string
}

export default function Theme({
  children,
  primaryColor,
  secondaryColor
}: ThemeSiteProps) {
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: primaryColor || semantic.primary
          },
          secondary: {
            main: secondaryColor || '#343434'
          }
        }
      } as ThemeOptions),
    [primaryColor, secondaryColor]
  )

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
